import { HeroManifest } from '../../types';
import { HEADER_TEMPLATE_ECOMMERCE_SLIDER } from '../../../templateCodes';

export const manifest: HeroManifest = {
  code: HEADER_TEMPLATE_ECOMMERCE_SLIDER,
  label: 'Ecommerce Slider',
  fields: [],
};
